var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFence = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 15a1 1 0 1 1 2 0 1 1 0 0 1-2 0m0 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0m12.5-11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0m-22-11a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-1 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M16.59 4.192a1 1 0 0 0-1.18 0l-4 2.917a1 1 0 0 0-.41.808V14H9V7.558a1 1 0 0 0-.41-.807l-3.5-2.558a1 1 0 0 0-1.18 0L.41 6.75a1 1 0 0 0-.41.807V31a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-5h2v5a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-5h2v5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V7.558a1 1 0 0 0-.41-.807l-3.5-2.558a1 1 0 0 0-1.18 0l-3.5 2.558a1 1 0 0 0-.41.807V14h-2V7.917a1 1 0 0 0-.41-.808zM23 24v-8h-2v8zm-12 0H9v-8h2zm2 6V8.425l3-2.187 3 2.187V30zm12 0V8.066l2.5-1.827L30 8.066V30zM2 8.066V30h5V8.066L4.5 6.24z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
})))));
export default SvgFence;